import { render, staticRenderFns } from "./operateSetting.vue?vue&type=template&id=3cc87ada&"
import script from "./operateSetting.vue?vue&type=script&lang=js&"
export * from "./operateSetting.vue?vue&type=script&lang=js&"
import style0 from "./operateSetting.vue?vue&type=style&index=0&id=3cc87ada&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports